import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Video grid',
  name: 'videoGrid',
  type: 'object',
  fields: [
    defineField({
      title: 'Heading',
      name: 'heading',
      type: 'string',
    }),
    defineField({
      title: 'Videos',
      name: 'videos',
      type: 'array',
      of: [{ type: 'youtubeVideo' }],
    }),
    defineField({
      title: 'ID',
      name: 'id',
      type: 'string',
      description: `ID used for linking to this section in the navigation bar. Must be unique. ie. component with ID 'presentation-video' would be linked to with '#presentation-video' in the URL`,
    }),
  ],
  preview: {
    select: {
      videos: 'videos',
    },
    prepare({ videos }) {
      let title = 'No videos'
      if (videos?.length === 1) title = `1 video`
      if (videos?.length > 1) title = `${videos.length} videos`

      return {
        title,
        subtitle: 'Video grid',
      }
    },
  },
})